<template>
  <div style="border: 1px solid #ccc">
    <!-- <b-button @click="saveData">Guardar</b-button> -->
    <div class="div-table">
      <h3 class="titulo-c3">Cuadro 8</h3>
      <h3 class="titulo-c3">{{ title }}</h3>
    </div>

    <table class="table">
      <thead>
        <tr>
          <th scope="col">Tipo de Evaluacion</th>
          <th scope="col">Programa/Institución</th>
          <th scope="col">Año</th>
          <th scope="col">Estado</th>
          <th scope="col">Monto</th>
          <th scope="col">Link de descarga</th>
          <th scope="col">Evaluación Dipres (SI/NO)</th>
          <th scope="col">
            <b-button v-if="!readOnly" class="button-add" @click="addItemList">+</b-button>
          </th>
        </tr>
      </thead>
      <tbody>
        <Row
          v-for="(item, index) in itemList"
          :key="index"
          :removeItem="removeItem"
          :objTest="item"
          :index="index"
          :readOnly="readOnly"
        />
      </tbody>
    </table>
  </div>
</template>

<script>
import Row from "./Row.vue";
export default {
  components: {
    Row,
  },
  data() {
    return {
      title: `Cumplimiento de Compromisos de Programas / Instituciones Evaluadas `,
    };
  },
  props: ["removeItem", "addItemList", "itemList", "readOnly"],
};
</script>

<style scoped>
.titulo-c3 {
  font-size: 1.1rem;
  color: #2b425f;
  font-weight: bold;
  margin: 0;
  text-align: center;
}
.table > tbody,
.table > thead {
  vertical-align: middle;
}
.button-add {
  background: #25a2b7 !important;
  color: white !important;
  border: none;
  width: 25px;
  height: 25px;
  border-radius: 14px;
  padding: 0 !important;
  font-size: 1.5rem;
  font-weight: bold;
  line-height: 0;
}

.div-table {
  background: #efefef;
}
</style>
